module.exports = __webpack_public_path__ + "static/media/hair3.b868f342.png";